import { FC } from 'react';
import { PopoverMenu, usePopoverMenu, Text } from '@frontend/design-system';
import { TaskFormRow, PopoverMenuItems } from '../../common';

type LocationData = { id: string; name?: string };

interface LocationPickerProps {
  data: Array<LocationData>;
  label: string;
  placeholder: string;
  value: string;
  shouldRenderChildren: boolean;
  onSelect: (value: string) => void;
  isEditing?: boolean;
  isRemoveable?: boolean;
  trackingIds?: {
    removeButton?: string;
    chipButton?: string;
  };
}

export const LocationPicker: FC<LocationPickerProps> = ({
  data,
  label,
  placeholder,
  value,
  shouldRenderChildren = false,
  onSelect,
  trackingIds,
  isEditing = false,
  isRemoveable = true,
}) => {
  let children;

  const { getItemProps, getMenuProps, getTriggerProps, close } = usePopoverMenu({ placement: 'bottom-start' });

  const dataValue = data.find((item) => item.id === value)?.name ?? '';

  const onClickItem = (item: LocationData) => {
    onSelect(item.id);
    close();
  };

  if (data.length >= 1 && shouldRenderChildren) {
    children = (
      <PopoverMenu {...getMenuProps()}>
        <PopoverMenuItems<LocationData>
          data={data}
          getItemProps={getItemProps}
          renderItem={(item) => <Text>{item.name}</Text>}
          keyGen={(item) => `location-picker-${item.id}`}
          onClickItem={onClickItem}
        />
      </PopoverMenu>
    );
  }

  return (
    <TaskFormRow
      label={label}
      icon='locations'
      placeholder={placeholder}
      buttonIconName='location'
      value={dataValue}
      getTriggerProps={getTriggerProps}
      disabled={data.length === 1 || !shouldRenderChildren}
      trackingIds={trackingIds}
      isEditing={isEditing}
      isRemoveable={isRemoveable}
    >
      {!isEditing && children}
    </TaskFormRow>
  );
};
